import React from 'react'

const ImageCard = ({image}) => {
          const tags = image.tags.split(',')

  return (

          <div className="max-w-sm rounded overflow-hidden shadow-lg mx-8 ">
          <img src={image.webformatURL} alt="" className='w-full' style={{height
          :"50%"}}/>
          <div className="px-6 py-4 max-w-sm">
            <div className="font-bold text-purple-500 text-xl mb-2"> Photo by : {image.user}</div>
            <ul>
              <li>
                <strong>Views:</strong>{image.views}
              </li>
              <li>
                <strong>Download:</strong>{image.downloads}
              </li>
              <li>
                <strong>Likes:</strong>{image.likes}
              </li>
            </ul>
          </div>
       <div className="px-6 py-4">
        
       {
          tags.map((tag,index)=>{
                 return   <span key={index} className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">#{tag}</span>
          })
       }
    
       </div>
        </div>
  )
}

export default ImageCard